/**
 * SHA-256 of each binary schema this bundle reads FlatBuffers with, as LN2E
 * frames and `X-LN2-Schema` headers carry them: a frame or response whose
 * hash is one of these was written with this bundle's own schema.
 *
 * Generated by `npm run generate:schema-hashes` from the schemas embedded in
 * `src/flatbuffers/generated/`. Do not edit; a test fails when it is stale.
 */

/** `FrontEnd.FrontEndMessage`: single monitoring messages. */
export const FRONT_END_MESSAGE_SCHEMA_HASH =
  "6b9dbac9e471b8e67948d2c790cc90493edd17631397cbd4b389d8bbc654e109";

/** `BatchedFrontEnd.BatchedFrontEndMessage`: the monitoring WebSocket's batches. */
export const BATCHED_FRONT_END_MESSAGE_SCHEMA_HASH =
  "e50fa3b9096c1df7e9134e33fef060a6b49f52e87fc62afa35c870b6998335e5";

/** `Api.ApiSchema`: every FlatBuffer HTTP body's type (`X-LN2-Schema`). */
export const API_SCHEMA_HASH = "3873029c6f59dda937e2982ead4987ea27ecf1aacaff4c629fab647cb53fde56";
